const GraphSkeleton = ({ loading = false }: { loading?: boolean }) => (
  <div className="relative w-full h-[480px] md:h-[450px] sm:h-[360px] bg-white border rounded-lg p-4 pt-1 shadow-sm overflow-hidden">
    <div className="animate-pulse relative w-full h-full">
      {[...Array(6)].map((_, i) => (
        <div key={`h-${i}`} className="absolute left-10 right-2 border-t border-gray-200" style={{ top: `${(i + 1) * 14}%` }} />
      ))}
      {[...Array(8)].map((_, i) => (
        <div key={`v-${i}`} className="absolute top-4 bottom-8 border-l border-gray-200" style={{ left: `${(i + 1) * 11}%` }} />
      ))}

      <div className="absolute left-8 right-2 bottom-8 border-t border-gray-400" />
      <div className="absolute top-4 bottom-8 left-8 border-l border-gray-400" />

      <svg viewBox="0 0 400 200" className="absolute inset-0 w-full h-full opacity-40">
        <path d="M0,150 Q80,110 160,130 T320,90 T400,120" fill="none" stroke="#93c5fd" strokeWidth="3" strokeLinecap="round" />
      </svg>

      <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/60 backdrop-blur-[1px] text-center">
        {loading ? (
          <p className="text-gray-500 text-sm">Loading…</p>
        ) : (
          <>
            <p className="text-gray-700 font-medium text-md mb-1">No data available</p>
            <p className="text-gray-500 text-sm">Try adjusting filters or date range</p>
          </>
        )}
      </div>
    </div>
  </div>
);

export default GraphSkeleton;